import React from 'react';
import { Input, Button, Space } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import TriState from 'components/mantenciones/TriState';

// El checklist del reporte usa OK/FALLA/NA; el átomo TriState habla
// EXITOSO/RECHAZADO/NA. Mapeamos en ambos sentidos para reusarlo tal cual.
const TO_TRI = { OK: 'EXITOSO', FALLA: 'RECHAZADO', NA: 'NA' };
const FROM_TRI = { EXITOSO: 'OK', RECHAZADO: 'FALLA', NA: 'NA' };

function BloqueChecklist({ block, onChange }) {
  const items = block.config?.items || [];
  const setItems = (next) => onChange({ config: { items: next } });
  const update = (i, patch) =>
    setItems(items.map((it, idx) => (idx === i ? { ...it, ...patch } : it)));
  const add = () => setItems([...items, { label: '', estado: 'NA' }]);
  const remove = (i) => setItems(items.filter((_, idx) => idx !== i));

  return (
    <div>
      {items.map((it, i) => (
        <div
          key={i}
          style={{ marginBottom: 12, borderBottom: '1px solid #f0f0f0', paddingBottom: 8 }}
        >
          <Space.Compact style={{ width: '100%' }}>
            <Input
              placeholder="Ítem (ej. Puertas, Cabina, Foso…)"
              value={it.label}
              onChange={(e) => update(i, { label: e.target.value })}
            />
            <Button danger icon={<DeleteOutlined />} onClick={() => remove(i)} />
          </Space.Compact>
          <TriState
            value={TO_TRI[it.estado] || 'NA'}
            onPick={(v) => update(i, { estado: v ? FROM_TRI[v] : 'NA' })}
          />
          <Input
            placeholder="Nota (opcional)"
            value={it.nota || ''}
            onChange={(e) => update(i, { nota: e.target.value })}
            style={{ marginTop: 8 }}
          />
        </div>
      ))}
      <Button icon={<PlusOutlined />} onClick={add} block>
        Agregar ítem
      </Button>
    </div>
  );
}

export default BloqueChecklist;
